import { POST_TO_PARENT } from '@instructure/quiz-common';
import { postToParent } from '../util/crossDomainMessaging';
var crossDomainMessagingMiddleware = function crossDomainMessagingMiddleware(store) {
  return function (next) {
    return function (action) {
      if (action.type === POST_TO_PARENT) {
        postToParent(action.payload);
      }
      return next(action);
    };
  };
};
export default crossDomainMessagingMiddleware;